export const CommentData = {
    comment: "",
    name: "",
    userid: "",
    userimage: "",
    createdon: new Date('1995-12-17T03:24:00'),
}